import { 
  Component, 
  OnInit, 
  ViewChild, 
  HostListener, 
  ViewChildren, 
  QueryList, 
  AfterViewInit,
  ElementRef 
} from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { 
  PerfectScrollbarDirective, 
  PerfectScrollbarConfigInterface 
} from 'ngx-perfect-scrollbar';
import { AppSettings } from '../app.settings';
import { Settings } from '../app.settings.model';
import { rotate } from '../theme/utils/app-animation';
import { MenuService } from '../theme/components/menu/menu.service';
import { SharedService } from '../shared/shared.service';

@Component({
  selector: 'app-pages',
  templateUrl: './pages.component.html',
  styleUrls: ['./pages.component.scss'],
  animations: [ rotate ],
  providers: [ MenuService ]
})
export class PagesComponent implements OnInit, AfterViewInit {

  @ViewChild('sidenav') sidenav: any;
  @ViewChild('backToTop') backToTop!: ElementRef;
  @ViewChildren(PerfectScrollbarDirective) pss!: QueryList<PerfectScrollbarDirective>;

  // Perfect Scrollbar config
  public optionsPsConfig: PerfectScrollbarConfigInterface = {
    wheelPropagation: false,
    suppressScrollX: true
  };

  public settings: Settings;
  public showSidenav = false;
  public showInfoContent = false;
  public toggleSearchBar = false;
  public menuOption: string;
  public menuTypeOption: string;
  public menus = ['vertical', 'horizontal'];
  public menuTypes = ['default', 'compact', 'mini'];
  public branches: any;
  public selectedBranch: any;
  public currentDate = '';

  private defaultMenu: string;

  constructor(
    public appSettings: AppSettings,
    public router: Router,
    private menuService: MenuService,
    private sharedService: SharedService
  ) {
    this.settings = this.appSettings.settings;
    this.getBranches();
    this.selectedBranch = Number(localStorage.getItem('branch'));
  }

  ngOnInit() {
    this.updateCurrentDate();

    if (window.innerWidth <= 960) {
      this.settings.menu = 'vertical';
      this.settings.sidenavIsOpened = false;
      this.settings.sidenavIsPinned = false;
    }

    this.menuOption = this.settings.menu;
    this.menuTypeOption = this.settings.menuType;
    this.defaultMenu = this.settings.menu;
  }

  ngAfterViewInit() {
    setTimeout(() => this.settings.loadingSpinner = false, 300);

    // Hide back-to-top initially
    if (this.backToTop) {
      this.backToTop.nativeElement.style.display = 'none';
    }

    // Auto-scroll to top on navigation
    this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        this.scrollToTop();
      }

      if (window.innerWidth <= 960) {
        this.sidenav.close();
      }
    });

    // Expand active submenu
    if (this.settings.menu === 'vertical') {
      this.menuService.expandActiveSubMenu(this.menuService.getVerticalMenuItems());
    }
  }

  updateCurrentDate() {
    const today = new Date();
    const options: Intl.DateTimeFormatOptions = {
      weekday: 'long', year: 'numeric', month: 'long', day: 'numeric'
    };
    this.currentDate = today.toLocaleDateString('en-US', options);
  }

  // Window resizing behavior
  @HostListener('window:resize')
  onWindowResize(): void {
    if (window.innerWidth <= 960) {
      this.settings.sidenavIsOpened = false;
      this.settings.sidenavIsPinned = false;
      this.settings.menu = 'vertical';
    } else {
      this.settings.menu = (this.defaultMenu === 'horizontal') ? 'horizontal' : 'vertical';
      this.settings.sidenavIsOpened = true;
      this.settings.sidenavIsPinned = true;
    }
  }

  // Called by (psScrollY)
  onPsScrollY(event: any): void {
    const show = event.target.scrollTop > 300;

    if (this.backToTop) {
      this.backToTop.nativeElement.style.display = show ? 'flex' : 'none';
    }
  }

  // Scroll container to top smoothly
  scrollToTop(): void {
    this.pss.forEach(ps => {
      const element = ps.elementRef.nativeElement;

      if (element.id === 'main') {
        ps.scrollToTop(0, 250);
      }
    });
  }

  toggleSidenav(): void {
    this.sidenav.toggle();
  }

  chooseMenu(): void {
    this.settings.menu = this.menuOption;
    this.defaultMenu = this.menuOption;

    if (this.menuOption === 'horizontal') {
      this.settings.fixedSidenav = false;
    }

    this.router.navigate(['/']);
  }

  chooseMenuType(): void {
    this.settings.menuType = this.menuTypeOption;
  }

  changeTheme(theme: string): void {
    this.settings.theme = theme;
  }

  closeInfoContent(showInfoContent: boolean): void {
    this.showInfoContent = !showInfoContent;
  }

  closeSubMenus(): void {
    if (this.settings.menu === 'vertical') {
      this.menuService.closeAllSubMenus();
    }
  }

  getBranches(): void {
    // Leave your original implementation
  }

  onBranchChange(): void {
    // Leave your original implementation
  }

  reLoad(): void {
    this.router.navigate(['/']);
  }
}
